import React from 'react';
import Icon from '../../../components/appIcon';
import Image from '../../../components/appImage';
import Button from '../../../components/ui/button';

const BACKEND_URL = import.meta.env.VITE_API_URL;
const AttendanceRowDetails = ({ record }) => {
  const formatDateTime = (timestamp) => {
    if (!timestamp) return '--';
    return new Date(timestamp)?.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  const formatCoordinates = (lat, lng) => {
    if (!lat || !lng) return '--';
    return `${lat?.toFixed(6)}, ${lng?.toFixed(6)}`;
  };
  const formatDuration = (checkIn, checkOut) => {
    if (!checkIn || !checkOut) return '--';
    const diff = new Date(checkOut) - new Date(checkIn);
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    return `${hours}h ${minutes}m`;
  };
  return (
    <div className="bg-muted/30 border-t border-border">
      <div className="p-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Left Column - Details */}
          <div className="space-y-4">
            <h4 className="text-sm font-semibold text-foreground mb-3">Attendance Details</h4>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
                  Check In Time
                </label>
                <p className="text-sm text-foreground mt-1">{formatDateTime(record?.checkIn)}</p>
              </div>
              <div>
                <label className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
                  Check Out Time
                </label>
                <p className="text-sm text-foreground mt-1">{formatDateTime(record?.checkOut)}</p>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
               
              <div>
                <label className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
                  Duration
                </label>
                <p className="text-sm text-foreground mt-1">{formatDuration(record?.checkIn, record?.checkOut)}</p>
              </div>
              <div>
                <label className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
                  Camera ID
                </label>
                <p className="text-sm text-foreground mt-1 font-mono">{record?.cameraId}</p>
              </div>
            </div>
        {record?.notes && (
              <div>
                <label className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
                  Administrative Notes
                </label>
                <p className="text-sm text-foreground mt-1 p-3 bg-card rounded border border-border">
                  {record?.notes}
                </p>
              </div>
            )}
          </div>
          {/* Right Column - Images and Actions */}
          <div className="space-y-4">
            <h4 className="text-sm font-semibold text-foreground mb-3">Capture Images</h4>
            <div className="grid grid-cols-2 gap-4">
              {record?.captureImage && (
                <div>
                  <label className="text-xs font-medium text-muted-foreground uppercase tracking-wide mb-2 block">
                    Attendance Capture
                  </label>
                  <div className="relative group">
                    <div className="w-full h-32 bg-muted rounded-lg overflow-hidden">
                      <Image
                        src={`${BACKEND_URL}${record?.captureImage}`}
                        alt="Attendance capture"
                        className="w-full object-cover"
                      />
                    </div>
                    <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-200 rounded-lg flex items-center justify-center">
                      <Button
                        variant="ghost"
                        size="icon"
                        className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 bg-white/90 hover:bg-white"
                      >
                        <Icon name="Expand" size={16} />
                      </Button>
                    </div>
                  </div>
                </div>
              )}
              {record?.profileImage && (
                <div>
                  <label className="text-xs font-medium text-muted-foreground uppercase tracking-wide mb-2 block">
                    Profile Reference
                  </label>
                  <div className="w-full h-32 bg-muted rounded-lg overflow-hidden">
                    <Image
                      src={record?.profileImage}
                      alt="Profile reference"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttendanceRowDetails;